import {
  Box,
  Button,
  Flex,
  Heading,
  Stack,
  Text,
  VStack,
  useToast,
} from "@chakra-ui/react";
import React from "react";
import { MdContentCopy } from "react-icons/md";
import { brandPalette } from "../../../../constants/brandPalette";
import MainModel from "../../../../components/Models/main-model";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
} from "../../../../components/Models/admin-modal-theme";

const ShowAssistantPassword = ({ data, isOpen, onClose }) => {
  const toast = useToast();
  const password = data?.unhashed_password ?? "";
  const phone = data?.phone ?? "";

  const handleCopy = async () => {
    if (!password) return;
    try {
      await navigator.clipboard.writeText(password);
      toast({
        title: "Password copied",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch {
      toast({
        title: "Could not copy",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    }
  };

  const header = (
    <Box>
      <Heading
        fontSize="28px"
        fontWeight="800"
        color="var(--text-primary)"
        fontFamily="'Amiri','Tajawal',sans-serif"
        textAlign="center"
      >
        Assistant password
      </Heading>
      <Text
        fontSize="xs"
        mt={1}
        color="var(--text-muted)"
        textTransform="uppercase"
        letterSpacing="0.12em"
        fontWeight="700"
        textAlign="center"
      >
        {data?.name || "Assistant"}
      </Text>
    </Box>
  );

  return (
    <MainModel
      header={header}
      closeFunc={onClose}
      openVar={isOpen}
      buttonTitle={null}
      size="md"
      contentProps={adminModalContentProps}
      headerProps={adminModalHeaderProps}
      bodyProps={{ ...adminModalBodyProps, pb: 6 }}
      hideDefaultFooter
    >
      <Stack spacing={8} dir="ltr" w="100%">
        <VStack align="stretch" spacing={5}>
          <Field label="Phone" value={phone} />
          <Field label="Password" value={password} mono />
        </VStack>
        <Flex justify="flex-end" gap={3} pt={2}>
          <Button
            leftIcon={<MdContentCopy />}
            onClick={handleCopy}
            isDisabled={!password}
            bg={brandPalette.primary}
            color="white"
            borderRadius="lg"
            fontWeight="800"
            _hover={{ bg: brandPalette.accentDark }}
            _disabled={{ opacity: 0.5, cursor: "not-allowed" }}
          >
            Copy
          </Button>
          <Button
            onClick={onClose}
            variant="ghost"
            color="var(--text-primary)"
            fontWeight="800"
            _hover={{ textDecoration: "underline", bg: "rgba(91, 13, 22, 0.08)" }}
          >
            Close
          </Button>
        </Flex>
      </Stack>
    </MainModel>
  );
};

const Field = ({ label, value, mono = false }) => (
  <Box>
    <Text
      as="span"
      display="block"
      fontSize="14px"
      fontWeight="700"
      color="var(--text-primary)"
      mb={2}
      textAlign="left"
    >
      {label}
    </Text>
    <Box
      px={4}
      py={3}
      bg="var(--surface-muted)"
      border="1px solid"
      borderColor="var(--border-subtle)"
      borderRadius="lg"
      fontSize="md"
      fontWeight="600"
      color="var(--text-primary)"
      fontFamily={mono ? "ui-monospace, monospace" : undefined}
      wordBreak="break-word"
    >
      {value || "—"}
    </Box>
  </Box>
);

export default ShowAssistantPassword;
